import { useTranslations } from "use-intl";
import { useWorkOrderRecord } from "@/app/ProDrivers/WorkOrders/Hooks/useWorkOrderRecord";
import { IncidentsTable } from "@/app/Incidents/Components/IncidentsTable";

export function WorkOrderIncidentsScreen() {
  const t = useTranslations("incident.workOrderIncidents");
  const workOrder = useWorkOrderRecord();

  return (
    <div className="py-6">
      <IncidentsTable
        id="work-order-incidents"
        searchable={false}
        filterVariables={{ work_order_id: workOrder.id }}
        removedColumns={["supplier", "work_order", "claim", "excess"]}
        emptyState={<p className="text-sm text-gray-500">{t("empty")}</p>}
      />
    </div>
  );
}
